import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { take } from 'rxjs/operators'

import { FinancialSummary } from '../../models'
import { FinancialObligationService } from '../../services/financial-obligation.service'

@Component({
  selector: 'app-dashboard-payments',
  templateUrl: './dashboard-payments.component.html',
  standalone: false,
})
export class DashboardPaymentsComponent implements OnInit {
  public loaded = false
  public failed = false
  public bills: FinancialSummary[] = []

  constructor(
    private financialObligationService: FinancialObligationService,
    private translate: TranslateService
  ) { }

  public ngOnInit(): void {
    this.load()
  }

  public load(): void {
    this.loaded = false
    this.failed = false
    this.financialObligationService.upcomingPayments().pipe(take(1)).subscribe({
      next: result => {
        this.bills = result
        this.formatPayments()
        this.loaded = true
      },
      error: () => {
        this.bills = []
        this.failed = true
        this.loaded = true
      },
    })
  }

  private formatPayments(): void {
    this.bills.forEach((payment) => {
      payment.tags = []

      if (payment.state.includes('PastDue')) {
        payment.tags = [{
          value: this.translate.instant('DASHBOARD.PAYMENTS.past_due'),
          color: this.translate.instant('DASHBOARD.PAYMENTS.color')
        }]
      }
      payment.view_sale = payment.state.includes('AutoPay')
    })
  }
}
